# automaticke akce

position_tracker = {}
taxametr_tracker = {}
messages_tracker = {}
planned_ride_tracker = {}
timer_tracker = {}
start_ride_tracker = {}
order_status_tracker = {}


# posila pozici do stacku
track_position = (time) ->
    clearInterval(position_tracker)
    if (time > 0)
        position_tracker = setInterval ->
            saveGPS()
            return
        , time

# pricita taxametr
start_taxametr = (time) ->
    clearInterval(taxametr_tracker)
    # kdyz je cas v2tsi nez nula, je aktivni jizda a taxamer ma bezet
    if time > 0
        taxametr_tracker = setInterval () ->
            if taxametr_status()
                reloadTaxametr()
            return
          , time
      return
    
# kontroluje jestli neprisla zprava
check_messages = (time) ->
    clearInterval(messages_tracker)
    if (time > 0)
        messages_tracker = setInterval ->
            if !$('#message').hasClass('shown')
                checkMessage()
            return
        , time

# kontroluje jestli nepribyla naplanovana jizda
check_planned_ride = (time) ->
    clearInterval(planned_ride_tracker)
    if time > 0 
        planned_ride_tracker = setInterval ->
            if !$('#message').hasClass('shown')
                checkPlannedRides()
            return
        , time

# kontroluje jestli uz nenastal start nejake jizdy
check_start_time = (time) ->
    clearInterval(start_ride_tracker)
    if time > 0 
        start_ride_tracker = setInterval ->
            checkStartRides()
            return
        , time

# cas jizdy
run_timer = (time) ->
    clearInterval(timer_tracker)
    
    if time > 0 
        timer_tracker = setInterval ->
            addSecond(1)
            return
        , time

# kontroluje jestli neprisla zprava
check_order_status = (time) ->
    clearInterval(order_status_tracker)
    if (time > 0)
        order_status_tracker = setInterval ->
            if $('#order_status').length
                checkOrderStatus()
            return
        , time
